import React from "react";

import FooterSmall from "../components/FooterSmall.jsx";
import Navbar from "../../navbar_and_footer/Navbar.jsx";
import profilePic from "../assets/img/logo-long.png";
import profileGabi from "../assets/img/logo-gabi.png";
import Modal from "react-modal";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import transferFiles from "../../../Assets/transfer_files.gif";
import httpClient from "../../../utils/httpClient";
import axios from "axios";

export default function Login() {
  const eventId = useParams().id;

  const [name, setName] = useState(null);
  const [files, setFiles] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showMessage, setShowMessage] = useState(false); // Control final message display
  const [isFading, setIsFading] = useState(false); // Control for fade animation

  const [isShareDisable, setIsShareDisable] = useState(true);

  async function handlePresignedUrls(urls, files) {
    let successFlag = true;

    try {
      for (let i = 0; i < urls.length; i++) {
        // const filename = files[i].name;
        // const url = urls.find((url) => url === filename);

        // console.log(filename);
        // console.log(url);
        axios
          .put(urls[i], files[i])
          .then((response) => {
            httpClient.post(`/v1/logs`, JSON.stringify(response));
            successFlag = false;
          })
          .catch((err) => {
            httpClient.post(`/v1/logs`, JSON.stringify(JSON.stringify(err)));
            successFlag = false;
          });
      }
    } catch (error) {
      httpClient.post(`/v1/logs`, JSON.stringify(error));
    }

    if (successFlag) {
      setShowMessage(true);
    }
  }

  const handleButtonClick = () => {
    if (!files) {
      return;
    }

    setTimeout(() => {
      setIsModalOpen(true); // Open modal with delay
    }, 300);

    setIsFading(true); // Trigger fade effect on submit
    setTimeout(() => {
      setIsSubmitted(true); // Show the GIF after the fade effect
    }, 800); // Fade duration

    let filenames = [];

    for (let i = 0; i < files.length; i++) {
      filenames.push(files[i].name.replace(/\s+/g, "_"));
    }

    let presignRequest = {
      sender: name,
      filenames: filenames,
    };

    httpClient
      .put(`/v1/events/${eventId}/photos`, presignRequest)
      .then((res) => {
        handlePresignedUrls(res.data, files);
      })
      .catch((err) => console.error(err));

    setName("");
    setFiles(null);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsSubmitted(false);
    setShowMessage(false); // Reset message state
    setIsFading(false); // Reset fade state when closing modal
    window.location.reload();
  };

  return (
    <>
      <Navbar transparent></Navbar>
      <main>
        <section className="absolute w-full min-h-full align-middle justify-center flex flex-col">
          <div className="absolute top-0 w-full h-full bg-gray-950 bg-center"></div>
          <div className="container px-4">
            <div className="flex">
              <div className="w-full lg:w-4/12 px-4 flex flex-col justify-center align-middle items-center">
                <div
                  className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300 border-0 pt-80"
                  style={{
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${
                      eventId === "bfe6245e1"
                        ? profilePic
                        : eventId === "a324a4e20"
                        ? profileGabi
                        : null
                    })`,
                    backgroundSize: "100%",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="flex-auto px-4 lg:px-10 py-10 pt-0  bg-gray-300 opacity-80 m-8 rounded-xl">
                    <div className="text-gray-500 text-center mb-3 font-bold pt-10 flex justify-center align-middle items-center"></div>
                    <form>
                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-gray-700 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                          placeholder="Add your name here"
                          style={{ transition: "all .15s ease" }}
                        />
                      </div>

                      <div className="relative w-full mb-3">
                        <label
                          className="block uppercase text-gray-700 text-xs font-bold mb-2"
                          htmlFor="grid-password"
                        >
                          Photos
                        </label>
                        <input
                          type="file"
                          multiple
                          onChange={(e) => {
                            setFiles(e.target.files);

                            if (e.target.files.length > 0) {
                              setIsShareDisable(false);
                            } else {
                              setIsShareDisable(true);
                            }
                          }}
                          className="border-0 px-3 py-3 placeholder-gray-400 text-gray-700 bg-transparent rounded text-sm  focus:outline-none focus:ring w-full"
                          style={{ transition: "all .15s ease" }}
                        />
                      </div>

                      <div className="text-center mt-6">
                        <button
                          onClick={handleButtonClick}
                          disabled={isShareDisable}
                          className={`text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ${
                            isShareDisable ? "bg-gray-700" : "bg-gray-900"
                          }`}
                          type="button"
                          style={{ transition: "all .15s ease" }}
                        >
                          Share
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <Modal
                isOpen={isModalOpen}
                onRequestClose={handleCloseModal}
                className="flex justify-center items-center bg-white p-6 rounded-lg shadow-md w-full sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-1/3 max-w-screen-md mx-4 md:mx-auto"
                overlayClassName="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center"
                ariaHideApp={false}
              >
                {/* Conditional rendering based on submission */}
                <div className="relative">
                  <div
                    className={`absolute flex flex-col items-center justify-center ${
                      showMessage ? "" : "hidden"
                    }`}
                  >
                    <h2 className="text-xl font-bold  align-middle items-center justify-center ">
                      Thank you for sharing your memories with us.
                    </h2>
                    <FaCheckCircle className="p-2 text-green-500 text-4xl w-28 h-28" />
                  </div>
                  <div
                    className={`flex flex-col items-center justify-center transition-opacity duration-1000 ${
                      isSubmitted ? "opacity-100" : "opacity-0"
                    } ${showMessage ? "invisible" : ""}`}
                  >
                    {/* GIF animation with fade-in effect */}
                    <img
                      src={transferFiles}
                      alt="Sending"
                      className="w-45 mb-4 transition-opacity duration-1000"
                    />
                  </div>
                </div>
              </Modal>
            </div>
          </div>

          <FooterSmall absolute />
        </section>
      </main>
    </>
  );
}
